import { createSelector } from 'reselect';

const selectDbnie = (state: any) => state.dbnie;


export const selectDbnieCurrentItem = createSelector([selectDbnie], (dbnie) => dbnie.current);

export const selectDbnieListItems = createSelector([selectDbnie], (dbnie) => dbnie.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectDbnieListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDbnieCreatedItem = createSelector([selectDbnie], (dbnie) => dbnie.create);

export const selectDbnieUpdatedItem = createSelector([selectDbnie], (dbnie) => dbnie.update);

export const selectDbnieQueryItems = createSelector([selectDbnie], (dbnie) => dbnie.query);

export const selectDbnieReadItem = createSelector([selectDbnie], (dbnie) => dbnie.read);

export const selectDbnieDeletedItem = createSelector([selectDbnie], (dbnie) => dbnie.delete);

export const selectDbnieSearchedItems = createSelector([selectDbnie], (dbnie) => dbnie.search);

export const selectDbnieItemsCount = createSelector([selectDbnie], (dbnie) => dbnie.count);

export const selectDbnieItemsFilter = createSelector([selectDbnie], (dbnie) => dbnie.filter);